//1=Super User, 2=ihunter admin 3=##, 4=Company admin, 5=Company User
export const navigation = [
  {
    text: 'Inicio',
    path: '/dash/home',
    icon: 'fad fa-user-chart',
    level: [1, 2, 3, 4, 5, 6,7],
  },
  {
    text: 'Solicitudes',
    path: '/dash/requests',
    icon: 'fad fa-clock',
    level: [1, 2, 3,7],
  },
  {
    text: 'Balances',
    path: '/dash/balances',
    icon: 'fad fa-coins',
    level: [1, 2, 3,7],
  },
  {
    text: 'Solicitudes de gastos',
    path: '/dash/user-requests', 
    icon: 'fad fa-comment-dollar',
    level: [1, 2, 3, 4, 7],
  },
  {
    text: 'Dispersiones',
    path: '/dash/admin/dispersions',
    icon: 'fad fa-envelope-open-dollar',
    level: [1, 2, 3,7],
  },
  {
    text: 'Dispersiones',
    path: '/dash/dispersions',
    icon: 'fad fa-envelope-open-dollar',
    level: [4, 5, 6],
  },
  {
    text: 'Pagos de servicios',
    path: '/dash/pagos-generales',
    icon: 'fad fa-lightbulb-dollar',
    level: [1],
  },  
  {
    text: 'Pagos de TAE',
    path: '/dash/pagos-tae',
    icon: 'fad fa-mobile',
    level: [1],
  },
  {
    text: 'Tercerización',
    icon: 'fad fa-money-check-edit-alt',
    level: [1, 2, 3, 4, 5, 6],
    items: [
      {
        text: 'Solicitudes',
        path: '/dash/payment-requests',
        level: [1, 2, 3, 4, 5, 6],
      },
      {
        text: 'CMG',
        path: '/dash/cmg',
        level: [1, 2, 3],
      }
    ]
  },
  {
    text: 'Reportes',
    path: '/dash/reports',
    icon: 'fad fa-chart-bar',
    level: [1, 2, 3,7],
    items: [
      {
        text: 'Tarjetas',
        path: '/dash/reports/cards',
        level: [1, 2, 3],
      }
    ]
  },
  {
    text: 'Programas',
    path: '/dash/programs',
    icon: 'fad fa-tasks',
    level: [1, 2, 3],
  },
  {
    text: 'Empresas',
    path: '/dash/companies',
    icon: 'fad fa-building',
    level: [1, 2, 3,7],
  },
  {
    text: 'Usuarios',
    path: '/dash/users',
    icon: 'fad fa-users',
    level: [1, 2, 3,7],
  },
  {
    text: 'Tarjetas',
    path: '/dash/cards',
    icon: 'fad fa-credit-card',
    level: [1, 2, 3],
  },
  {
    text: 'Mis Programas',
    path: '/dash/company',
    icon: 'fad fa-tasks',
    level: [4, 5, 6],
  },
  {
    text: 'Movimientos',
    path: '/dash/movements',
    icon: 'fad fa-receipt',
    level: [1, 2, 3, 4, 5, 6,7],
  },
  {
    text: 'Facturación',
    path: '/dash/invoices',
    icon: 'fad fa-file-invoice-dollar',
    level: [1, 2, 3, 4, 5, 6,7],
  },
  {
    text: 'Atención a Clientes',
    path: '/dash/notes',
    icon: 'fad fa-comment',
    level: [1, 2, 3],
  },
  {
    text: 'STP',
    icon: 'fad fa-tasks',
    level: [1, 2, 3],
    items: [
      {
        text: 'Abonos',
        path: '/dash/stp/abonos',
        level: [1, 2, 3],
      },
      {
        text: 'Ordenes de Pago',
        path: '/dash/stp/ordenesPago',
        level: [1, 2, 3],
      }
    ]
  },
  {
    text: 'API Logs',
    path: '/dash/api',
    icon: 'fad fa-tasks',
    level: [1, 2, 3]
  },

];
